import { AxiosResponse } from "axios";
import api from "service/apiService";
import { Role } from "./../../features/role/types";

export const getRoles = async (): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get("/role");
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const getPermissions = async (): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.get("/role/list/permission");
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});

export const updateRoles = async (roles: Role[]): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const response: AxiosResponse = await api.post(
				"/role/update-multiple",
				roles,
			);
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});
